import { GravelCalculationContextProvider } from "./gravelCalculation";
import { GravelCalculatorComponent } from "./gravelCalculator.component";

const GravelCalculator = () => {
    return (
        <div id="calculator">
            <GravelCalculationContextProvider>
                <GravelCalculatorComponent />
            </GravelCalculationContextProvider>
        </div>
    );
};

export { GravelCalculator };
